import {createSlice} from '@reduxjs/toolkit';

const gurujiChatSlice = createSlice({
  name: 'gurujichat',
  initialState: {
    isLoading: false,
    error:"",
    userChat:null,
    isDownloading:false,
    allChatHistory : [],
    FChatHistoryFDBlastDoc:null,
    chatHistoryTotalCount:0
  },
  reducers: {
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setChatByUserId: (state, action) => {
      state.userChat = action.payload;
    },
    startDownload: (state) => {
      state.isDownloading = true; 
    },
    finishDownload: (state) => {
      state.isDownloading = false; 
    },
    setAllChatHistory: (state,action) => {
      state.allChatHistory = action.payload;
    },
    setChatHistoryFDBlastDoc: (state,action) => {
      state.FChatHistoryFDBlastDoc= action.payload;
    },
    setChatHistoryTotalCount: (state,action) => {
      state.chatHistoryTotalCount= action.payload;
    },
  },
});

export const {
  setLoading,
  setError,
  setChatByUserId,
  startDownload,
  finishDownload,
  setAllChatHistory,
  setChatHistoryFDBlastDoc,
  setChatHistoryTotalCount
  
} = gurujiChatSlice.actions;

export default gurujiChatSlice.reducer;
